import { GlideInspector } from './glide-inspector';
import { GlideInspectorProps as _GlideInspectorProps } from './glide-inspector.model';

export { GlideInspector };
export type GlideInspectorProps = _GlideInspectorProps;
